import { useDialog } from "@shared/features/dialog/useDialog";
import { VideoUIDialogTypes } from "../../videoUI.types";
import { VideoUIEndMeetingDialog } from "../VideoUIEndMeetingDialog/VideoUIEndMeetingDialog";

export function VideoUIDialogs() {
  const { activeDialog } = useDialog();

  if (!["endMeeting"].includes(activeDialog || "")) {
    return null;
  }

  switch (activeDialog as VideoUIDialogTypes) {
    case "endMeeting":
      return <VideoUIEndMeetingDialog />;
    default:
      return null;
  }
}

export default VideoUIDialogs;
